<template>
  <v-tabs v-model="tab" center-active show-arrows>
    <v-tab
      v-for="item in items"
      :key="item.name"
      :href="`#${item.name}`"
      @click="$emit('click', item)"
    >
      <span v-if="!item.disableTooltip">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">{{ item.text }}</span>
          </template>
          <span>{{ item.description }}</span>
        </v-tooltip>
      </span>
      <span v-else>
        {{ item.text }}
      </span>
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    tab: {
      set (value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      // tab: null,
      // items: [
      //   { tab: 'แพ็คเกจ', content: 'Tab 1 Content' },
      //   { tab: 'บัญชีผู้ใช้', content: 'Tab 2 Content' },
      //   { tab: 'อนุมัติบัญชีผู้ใช้', content: 'Tab 3 Content' },
      //   { tab: 'Four', content: 'Tab 4 Content' }
      // ],
      offsetHeight: 0,
      windowSize: {
        x: 0,
        y: 0
      }
      // headers: [
      //   {
      //     text: 'Dessert (100g serving)',
      //     align: 'start',
      //     sortable: false,
      //     value: 'name'
      //   },
      //   { text: 'Calories', value: 'calories' },
      //   { text: 'Fat (g)', value: 'fat' },
      //   { text: 'Carbs (g)', value: 'carbs' },
      //   { text: 'Protein (g)', value: 'protein' },
      //   { text: 'Actions', value: 'actions', sortable: false },
      //   { text: '', value: 'data-table-expand' }
      // ],
      // itemss: [
      //   {
      //     name: 'Frozen Yogurt',
      //     calories: 159,
      //     fat: 6.0,
      //     carbs: 24,
      //     protein: 4.0
      //   },
      //   {
      //     name: 'Ice cream sandwich',
      //     calories: 237,
      //     fat: 9.0,
      //     carbs: 37,
      //     protein: 4.3
      //   }
      // ]
    }
  },
  methods: {
    // onResize () {
    //   this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    //   document.querySelector('.v-window.v-item-group').style.height = this.windowSize.y - 190 + 'px'
    //   // auto offset table
    //   this.offsetHeight = document.querySelector('.v-tabs').offsetHeight
    //   console.log(this.offsetHeight)
    // }
  }
}
</script>

<style lang="css" scoped>
/* .v-item-group {
  background: red;
} */

.v-window-item {
  height: 100% !important;
}

>>> .v-tabs-bar {
  background: none !important;
}
</style>
